import styles from "./Label.module.css";


function Label() {
  return <div className={styles.container}>
    <h1 className={styles.labelText}>Champion Select</h1>
  </div>;
}

export default Label;